import { render, staticRenderFns } from "./PhoneStep.vue?vue&type=template&id=7f68efda&"
import script from "./PhoneStep.vue?vue&type=script&lang=js&"
export * from "./PhoneStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f68efda')) {
      api.createRecord('7f68efda', component.options)
    } else {
      api.reload('7f68efda', component.options)
    }
    module.hot.accept("./PhoneStep.vue?vue&type=template&id=7f68efda&", function () {
      api.rerender('7f68efda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Onboarding/Components/PhoneStep.vue"
export default component.exports